// extracted by mini-css-extract-plugin
export default {"devices":"Devices_devices__v-Ykb","header":"Devices_header__RjzrH","title":"Devices_title__IxX6A","claimButton":"Devices_claimButton__W9XfJ"};